var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "12px",
    viewBox: "0 0 15 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Download Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Savings---Monthly-Breakdown",
    transform: "translate(-1363.000000, -276.000000)",
    fill: "#06B2BC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Electrical-Savings",
    transform: "translate(275.000000, 250.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download-Report-Button",
    transform: "translate(965.723487, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.214881,21.9005989 L131.911835,19.9375419 C132.100386,19.7194245 131.966576,19.339478 131.698956,19.339478 L130.610229,19.339478 L130.610229,13.7036047 C130.610229,13.3166221 130.336526,13 130.002001,13 C129.667476,13 129.393774,13.3166221 129.393774,13.7036047 L129.393774,19.3324419 L128.305047,19.3324419 C128.031345,19.3324419 127.897535,19.7123884 128.092167,19.9305059 L129.789122,21.8935629 C129.904685,22.0342838 130.099318,22.0342838 130.214881,21.9005989 L130.214881,21.9005989 Z M135.727273,13 L132.539091,13 C132.195455,13 131.909091,13.3 131.909091,13.66 C131.909091,14.0266667 132.195455,14.32 132.539091,14.32 L135.090909,14.32 C135.440909,14.32 135.727273,14.62 135.727273,14.9866667 L135.727273,23.0066667 C135.727273,23.3733333 135.440909,23.6733333 135.090909,23.6733333 L124.909091,23.6733333 C124.559091,23.6733333 124.272727,23.3733333 124.272727,23.0066667 L124.272727,14.9933333 C124.272727,14.6266667 124.559091,14.3266667 124.909091,14.3266667 L127.460909,14.3266667 C127.804545,14.3266667 128.090909,14.0266667 128.090909,13.6666667 C128.090909,13.3 127.804545,13 127.460909,13 L124.272727,13 C123.572727,13 123,13.6 123,14.3333333 L123,23.6666667 C123,24.4 123.572727,25 124.272727,25 L135.727273,25 C136.427273,25 137,24.4 137,23.6666667 L137,14.3333333 C137,13.6 136.427273,13 135.727273,13 Z",
    id: "Download-Icon"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.26adb39fd80dfa7d82c271fee762ed40.svg";
export { ForwardRef as ReactComponent };